import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Achievements from "./Achievements";
import Education from "./Education";
import Experience from "./Experience";
import PersonalInfo from "./PersonalInfo";
import Skills from "./Skills";
import Modal from "react-modal";
import toast from 'react-hot-toast';
import SupabaseClient from '../../utilities/SupabaseClient';

// Bind modal to the root element for screen-reader accessibility
Modal.setAppElement('#root');

const key = 'updatable';

const Index = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  function toggleModal() {
    reset({ name: "" });
    setIsModalOpen(!isModalOpen);
  }

  const onSubmit = async (data, e) => {
    setIsDownloading(true);
    toast.loading('Logging your request . . .', { id: key });

    try {
      const { ok, status, data: resData } = await SupabaseClient.logResumeDownload({
        name: data.name,
        honeypot: data.website, // Hidden honeypot — bots fill this, humans don't
      });

      if (ok) {
        // Use the resumeUrl and fileName returned by the Edge Function
        const { resumeUrl, fileName } = resData;
        const targetFileName = fileName || 'Devendra_Kumar_Full_Stack_CV.pdf';

        if (resumeUrl && resumeUrl.startsWith('http')) {
          try {
            // Fetch S3 file as a Blob to enforce the "download" file save behavior
            const response = await fetch(resumeUrl);
            if (!response.ok) throw new Error("Fetch failed");
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', targetFileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
          } catch (err) {
            // If S3 CORS blocks the Blob fetch, safely fallback to opening the PDF in a new tab
            window.open(resumeUrl, '_blank');
          }
        } else {
          // Local fallback — works beautifully with the standard download attribute
          const localUrl = resumeUrl || 'img/Devendra_Kumar_Resume.pdf';
          const link = document.createElement('a');
          link.href = localUrl;
          link.setAttribute('download', targetFileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        e.target.reset();
        reset({ name: '', website: '' });
        toggleModal();
        toast.success("Resume downloaded! Thanks for your interest.", { id: key, duration: 4000 });
      } else if (status === 429) {
        toast.error('You have already downloaded the resume recently. Try again later.', { id: key, duration: 5000 });
      } else {
        toast.error(resData?.error || 'Unable to process your request. Please try again later.', { id: key, duration: 4000 });
      }
    } catch (err) {
      console.error('[Download CV] Error:', err);
      toast.error('Network error. Please check your connection.', { id: key, duration: 4000 });
    } finally {
      setIsDownloading(false);
    }
  }

  return (
    <section className="main-content ">
      <Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        contentLabel="My dialog"
        className="custom-modal dark green"
        overlayClassName="custom-overlay"
        closeTimeoutMS={500}
      >
        <div>
          <button className="close-modal" onClick={toggleModal}>
            <img src="/img/cancel.svg" alt="close icon" />
          </button>
          {/* End close icon */}

          <div className="box_inner portfolio download-cv">
            <div className="slideshow contact">
              <figure>
                {/* Project Details Starts */}
                <figcaption>
                  <h3>GET MY RESUME</h3>
                  <form className="contactform get-my-resume" onSubmit={handleSubmit(onSubmit)}>

                    {/* Honeypot: hidden from real users, bots will fill it */}
                    <div style={{ position: 'absolute', left: '-9999px', opacity: 0, pointerEvents: 'none' }} aria-hidden="true">
                      <input
                        {...register('website')}
                        type="text"
                        name="website"
                        tabIndex={-1}
                        autoComplete="off"
                        placeholder="Leave this empty"
                      />
                    </div>

                    <div className="row open-sans-font">
                      <div className="col-12 mb-2">
                        <div className="form-group">
                          <input
                            {...register('name', { required: 'Name is required', minLength: { value: 2, message: 'Name too short' } })}
                            type="text"
                            name="name"
                            placeholder="Enter your name here . . ."
                            disabled={isDownloading}
                          />
                          {errors.name && (
                            <span className="invalid-feedback" style={{ marginLeft: '1.75rem', fontWeight: 600 }}>{errors.name.message}</span>
                          )}
                        </div>
                      </div>

                      {/* End .col */}
                      <div className="col-12 text-center">
                        <button type="submit" className="button" disabled={isDownloading}>
                          <span className="button-text">{isDownloading ? 'Processing...' : 'Download Now'}</span>
                          <span className={`button-icon fa ${isDownloading ? 'fa-spinner fa-spin' : 'fa-download'}`}></span>
                        </button>
                      </div>
                      {/* End .col */}
                    </div>
                  </form>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </Modal>
      <div className="container">
        <div className="row">
          {/* Personal Info Starts */}
          <div className="col-xl-6 col-lg-5 col-12">
            <div className="row">
              {/* <div className="col-12">
                <h3 className="text-uppercase custom-title mb-0 ft-wt-600">
                  personal infos
                </h3>
              </div> */}
              {/* End .col */}

              <div className="col-12 d-block d-sm-none">
                <img
                  src="img/hero/img-mobile.png"
                  className="img-fluid main-img-mobile"
                  alt="about avatar"
                />
              </div>
              {/* image for mobile menu */}

              <div className="col-12">
                <PersonalInfo />
              </div>
              {/* End personal info */}

              <div className="col-12 mt-1">
                {/* <a className="button" href="img/Devendra_Kumar_Resume.pdf" download>
                  <span className="button-text">Download CV</span>
                  <span className="button-icon fa fa-download"></span>
                </a> */}
                <button className="button" onClick={() => { toggleModal() }}>
                  <span className="button-text">Download CV</span>
                  <span className="button-icon fa fa-download"></span>
                </button>
              </div>
              {/* End download button */}
            </div>
          </div>
          {/*  Personal Info Ends */}

          {/*  Boxes Starts */}
          <div className="col-xl-6 col-lg-7 col-12 mt-5 mt-lg-0">
            <Achievements />
          </div>
          {/* Achievements Ends */}
        </div>
        {/* End .row */}

        <hr className="separator" />

        {/* Skills Starts */}
        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase pb-4 pb-sm-5 mb-3 mb-sm-0 text-left text-sm-center custom-title ft-wt-600">
              My Skills
            </h3>
          </div>
          <Skills />
        </div>
        {/* Skills Ends */}

        <hr className="separator mt-1" />

        {/* Experience & Education Starts */}
        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase pb-5 mb-0 text-left text-sm-center custom-title ft-wt-600">
              Experience <span>&</span> Education
            </h3>
          </div>
          <div className="col-lg-6 m-15px-tb">
            <div className="resume-box">
              <Experience />
            </div>
          </div>
          <div className="col-lg-6 m-15px-tb">
            <div className="resume-box">
              <Education />
            </div>
          </div>
        </div>
        {/*  Experience & Education Ends */}
      </div>
    </section>
  );
};

export default Index;
